import { render, staticRenderFns } from "./CopyrightMessages.vue?vue&type=template&id=1dfca7ce&scoped=true&"
import script from "./CopyrightMessages.vue?vue&type=script&lang=js&"
export * from "./CopyrightMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfca7ce",
  null
  
)

export default component.exports